import IConSystemName from '@/assets/img/svg/system_name.svg?inline'
// 终端
import IconHospital from '@/assets/img/svg/icon_hospital.svg?inline'
import IconBusiness from '@/assets/img/svg/icon_business.svg?inline'
import IconChain from '@/assets/img/svg/icon_chain.svg?inline'
import IconOther from '@/assets/img/svg/icon_other.svg?inline'
import IconPharmacy from '@/assets/img/svg/icon_pharmacy.svg?inline'
import IconNaturalPerson from '@/assets/img/svg/icon_natural_person.svg?inline'
import IconDistributor from '@/assets/img/svg/icon_distributor.svg?inline'

import IconImport from '@/assets/img/svg/icon_import.svg?inline' // 导入
import IconUpdate from '@/assets/img/svg/icon_update.svg?inline' // 更新
import IconDelete from '@/assets/img/svg/icon_delete.svg?inline' // 删除
import IconRelationship from '@/assets/img/svg/icon_relationship.svg?inline' // 关联关系
import IconEdit from '@/assets/img/svg/icon_edit.svg?inline' // 编辑
import IconTabInstall from '@/assets/img/svg/icon_tab_install.svg?inline' // tab栏配置
import IconCloseFile from '@/assets/img/svg/icon_close_file.svg?inline' // 停用档案

// 部门树形图标
import IconCompany from '@/assets/icon/icon_company.svg?inline'
import IconDepartment from '@/assets/icon/icon_department.svg?inline'

import IconNoData from '@/assets/img/svg/img_no_data.svg?inline' // 无数据
import IconFolder from '@/assets/img/svg/img_folder.svg?inline' // 文件夹
import IconDataFile from '@/assets/img/svg/img_data_file.svg?inline' // 文件
import IconDrag from '@/assets/img/svg/icon_drag.svg?inline' // 拖拽
import IconImportFiles from '@/assets/img/svg/icon_import_files.svg?inline' // 导入档案
import IconDragFile from '@/assets/img/svg/img_drag_file.svg?inline' // 拖拽图片

import IconExcel from '@/assets/img/svg/img_excel.svg?inline' // excel图标
import IconHistoricalDocuments from '@/assets/img/svg/img_historical_documents.svg?inline' // 文件夹图标 闭合

// 产品单价设置
import IconBusinessPrice from '@/assets/img/svg/icon_business_price.svg?inline'
import IconHospitalPrice from '@/assets/img/svg/icon_hospital_price.svg?inline'
import IconPharmacyPrice from '@/assets/img/svg/icon_pharmacy_price.svg?inline'
import IconAssessmentPrice from '@/assets/img/svg/icon_assessment_price.svg?inline'

// 导航图标
import IconMenuHome from '@/assets/img/menu/icon_home.svg?inline'
import TextMenuHome from '@/assets/img/menu/word_home.svg?inline'
import IconMenuManage from '@/assets/img/menu/icon_manage.svg?inline'
import TextMenuManage from '@/assets/img/menu/word_manage.svg?inline'
import IconMenuData from '@/assets/img/menu/icon_data.svg?inline'
import TextMenuData from '@/assets/img/menu/word_data.svg?inline'
import IconMenuFlow from '@/assets/img/menu/icon_flow.svg?inline'
import TextMenuFlow from '@/assets/img/menu/word_flow.svg?inline'
// 审批流
import IconApprover from '@/assets/img/approval/icon_approver.svg?inline'
import IconConditionalBranch from '@/assets/img/approval/icon_conditional_branch.svg?inline'
import IconCopier from '@/assets/img/approval/icon_copier.svg?inline'
export {
  // 导航
  IconMenuHome,
  TextMenuHome,
  IconMenuManage,
  TextMenuManage,
  IconMenuData,
  TextMenuData,
  IconMenuFlow,
  TextMenuFlow,
  IconHospital,
  IconBusiness,
  IconChain,
  IconOther,
  IconPharmacy,
  IconNaturalPerson,
  IconDistributor,
  IconImport,
  IconUpdate,
  IconDelete,
  IconRelationship,
  IconEdit,
  IconCompany,
  IconDepartment,
  IconNoData,
  IconFolder,
  IConSystemName,
  IconDrag,
  IconImportFiles,
  IconDataFile,
  IconDragFile,
  IconExcel,
  IconBusinessPrice,
  IconHospitalPrice,
  IconPharmacyPrice,
  IconApprover,
  IconConditionalBranch,
  IconCopier,
  IconTabInstall,
  IconHistoricalDocuments,
  IconCloseFile,
  IconAssessmentPrice
}
